<template>
  <div class="flex flex-col items-center">
    <div class="w-full border-b py-2 flex justify-center">
      <div class="w-full max-w-xs flex items-center justify-around">
        <div
          class="p-3 cursor-pointer"
          @click="current = current.clone().subtract(1, 'months')"
        >
          <icon name="chevron_left" :center="false" class="h-4 w-4" />
        </div>
        <span class="w-32 text-center font-bold">{{ current.format('MMMM YYYY') }}</span>
        <div
          class="p-3 cursor-pointer"
          @click="current = current.clone().add(1, 'months')"
        >
          <icon name="chevron_right" :center="false" class="h-4 w-4" />
        </div>
      </div>
    </div>

    <div class="w-full flex items-center justify-between border-b">
      <span class="w-8 h-8 m-1 p-2 text-sm text-center">Mo</span>
      <span class="w-8 h-8 m-1 p-2 text-sm text-center">Tu</span>
      <span class="w-8 h-8 m-1 p-2 text-sm text-center">We</span>
      <span class="w-8 h-8 m-1 p-2 text-sm text-center">Th</span>
      <span class="w-8 h-8 m-1 p-2 text-sm text-center">Fr</span>
      <span class="w-8 h-8 m-1 p-2 text-sm text-center">Sa</span>
      <span class="w-8 h-8 m-1 p-2 text-sm text-center">Su</span>
    </div>

    <div
      v-for="(week, wIndex) in weeks"
      :key="'week-' + wIndex"
      class="w-full flex items-center justify-between"
    >
      <span
        v-for="(day, dIndex) in week"
        :key="`d-${dIndex}-w${wIndex}}`"
        class="text-sm m-1 p-2 w-8 h-8 text-center flex items-center justify-center rounded-full cursor-pointer"
        :class="{
          'opacity-25': day.endOf('day') < now || day.month() !== current.month(),
          'bg-tertiary text-white': value.format('MMM D YYYY') === day.format('MMM D YYYY')
        }"
        @click="selectDay(day)"
      >
        {{ day.format('D') }}
      </span>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Icon from '@/components/Icon'

export default {
  name: 'Calendar',

  props: {
    disabled: {
      type: Boolean
    },
    value: {
      type: moment.moment,
      default: moment().local()
    }
  },

  components: {
    Icon
  },

  data () {
    return {
      current: moment().local(),
      now: moment().local()
    }
  },

  computed: {
    startDate () {
      const startOfMonth = this.current.clone().startOf('month')
      return startOfMonth.subtract(startOfMonth.weekday() - 1, 'days')
    },

    weeks () {
      const days = 6 * 7
      let weeks = [[], [], [], [], [], []]
      for (let i = 0; i < days; i++) {
        const index = Math.floor(i / 7)
        weeks[index].push(
          this.startDate.clone().add(i, 'days')
        )
      }
      return weeks
    }
  },

  methods: {
    selectDay (day) {
      if (this.disabled) {
        return
      }

      if (!(day.endOf('day') < this.now || day.month() !== this.current.month())) {
        this.$emit('input', day)
      }
    }
  }
}
</script>

<style scoped>
.halo {
  box-shadow: 0px 0px 0px 4px #5BCEAE50
}
</style>
